// {{BASE_URL}}
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

/** registerUser  */
export interface IRegisterUserInput {
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  mobileNumber: string[];
}

export const registerUser = async (
  payload: IRegisterUserInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/oauth/register`,
    {
      body: payload,
    }
  );

  return data;
};
